import './CacheComponent.core.js';

new wonderwp.CachePluginComponent();
